export const AuditorsTestStructure = (data)=>{
    const result={}
    const partNames = Object.keys(data);
    partNames.forEach((partName)=>{
        const categoriesNames = Object.keys(data[partName]);
        const partNameValue={}
        categoriesNames.forEach((categoryName)=>{
            // console.log(data[partName][categoryName]["1"]["1"]["additional_info"]["category_code"])
            Object.assign(partNameValue,{[categoryName]:[]});
        })
        Object.assign(result,{[partName]:partNameValue});
    })
    return result;
} 

export const AuditorsTestStructureAll =(data)=>{
    const result={}
    const partNames = Object.keys(data);
    partNames.forEach((partName)=>{
        result[partName]=[];
    })
    return (result)
}


export const AuditorsTestShortNames = (data) =>{
    const result={}
    const partNames = Object.keys(data);
    partNames.forEach((partName)=>{
        const categoriesNames = Object.keys(data[partName]);
        const partNameValue={}
        categoriesNames.forEach((categoryName)=>{
            // console.log(data[partName][categoryName]["1"]["1"]["additional_info"]["category_code"])
            const category_code=data[partName][categoryName]["1"]["1"]["additional_info"]["category_code"];
            Object.assign(partNameValue,{[categoryName]:category_code});
        })
        Object.assign(result,{[partName]:partNameValue});
    })
    return result;
}